import http from './../../http';

const sys = {
    speechRecognize(data: ArrayBuffer, orderId: number): Promise<ITaskStore.ISpeechRecognizeResponse> {
        return http.post(`/verify/orderId/${orderId}/skill/speech_recognize`, data);
    },
    create(params: ITaskStore.ICreateTaskBody): Promise<ITaskStore.ICreateResponse> {
        return http.post('/verify/task', params);
    },
    verify(): Promise<ITaskStore.IVerifyDetailResponse> {
        return http.get('/verify/task', {});
    },
    verifyFace(orderId: number): Promise<any> {
        return http.post(`/verify/task/orderId/${orderId}/face`, {});
    },
    verifyPerson(orderId: number): Promise<ITaskStore.IVerifyPersonResponse> {
        return http.post(`/verify/task/orderId/${orderId}/person`, {});
    },
    start(data: ITaskStore.IStartBody): Promise<ITaskStore.IStartResponse> {
        data.deviceInfo = navigator.userAgent;
        return http.post('/verify/task/start', data || {});
    },
    verifyFailed(data: ITaskStore.IVerifyFailedBody): Promise<any> {
        return http.put(`/verify/task/failed`, data);
    },
    getVideoEvent(bizKey: string): Promise<any[]> {
        return http.get(`/sys/biz/events/bizkey/${bizKey}`, {}, process.env.RECORD_BASE_URL);
    },
    getVideoUrl(taskId: string): Promise<ITaskStore.IRecallResponse> {
        return http.post(`/cms/recall/${taskId}`, {});
    },
    endRecord(taskId: string, errCode?: 0 | 1): Promise<void> {
        return http.post(`/cms/recall/end/${taskId}`, { errCode });
    },
    text2audio(orderId: number, text: string): Promise<any> {
        return http.get(`/verify/orderId/${orderId}/skill/text2audio/?text=${text}`, {});
    },
    uploadImg(img: string): Promise<any> {
        return http.post(`/verify/task/upload/image`, { image: img });
    },
    getSteps(tenantCode: string): Promise<ITaskStore.IStepsRes> {
        return http.get(`/openapi/verify/steps/${tenantCode}`, {});
    },
    createTask(
        tenantCode: string,
        stepsBizId: string,
        data?: { name?: string; idCardNum?: string }
    ): Promise<ITaskStore.ICreateTaskRes> {
        return http.post(`/openapi/verify/task/tenant/${tenantCode}/steps/${stepsBizId}`, data || {});
    },
    electronStart(): Promise<IElectronStore.IElectronStartRes> {
        return http.put('/esign/task/start', {});
    }
};

export default sys;
